import { SharedState } from '@trello/shared-state';

export interface BoardStar {
  id: string;
  idBoard: string;
  pos: number;
  __typename: 'BoardStar';
}

export const starredBoardsState = new SharedState<{
  starredBoards: BoardStar[];
}>({ starredBoards: [] });
